var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_335_2339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6583 2.99167C14.3417 2.675 13.9167 2.5 13.475 2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V6.525C17.5 6.08333 17.325 5.65833 17.0083 5.35L14.6583 2.99167ZM10 15.8333C8.61667 15.8333 7.5 14.7167 7.5 13.3333C7.5 11.95 8.61667 10.8333 10 10.8333C11.3833 10.8333 12.5 11.95 12.5 13.3333C12.5 14.7167 11.3833 15.8333 10 15.8333ZM10.8333 7.5H5.83333C4.91667 7.5 4.16667 6.75 4.16667 5.83333C4.16667 4.91667 4.91667 4.16667 5.83333 4.16667H10.8333C11.75 4.16667 12.5 4.91667 12.5 5.83333C12.5 6.75 11.75 7.5 10.8333 7.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_335_2339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.d09eee5a535a60a27e9cca2416a86c23.svg";
export { ForwardRef as ReactComponent };